module.exports = __webpack_public_path__ + "img/1539984284.3ce4d3b9.jpg";